<template>
  <div v-click-outside="hideDropdown" class="relative">
    <button
      v-tooltip="{
        content: `<div style='max-width: 550px;'>View Notifications</div>`,
        html: true,
        placement: 'auto',
        distance: 10,
      }"
      class="w-[22px] h-[22px] relative flex items-center"
      :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
      @click="toggleDropDown"
    >
      <BellRing :size="22" :stroke-width="1.75" />
      <span
        v-if="notificationList.length"
        class="absolute pulse-notif -top-1 -right-1 flex items-center justify-center min-w-[5px] min-h-[5px] rounded-full bg-primary-100 text-white-100 leading-none"
      ></span>
    </button>
    <div
      class="absolute top-full mt-2 right-0 border rounded-md min-w-72"
      :class="[
        dropdownClass,
        mode === 'dark' ? 'bg-dark-90 border-dark-70' : 'bg-white-100',
      ]"
    >
      <div
        class="flex items-center justify-between px-2 py-3 border-b"
        :class="mode === 'dark' ? 'border-dark-70' : ''"
      >
        <div class="flex items-center gap-1">
          <h5 class="font-medium leading-none">Notifications</h5>
          <span
            class="flex items-center justify-center min-w-[20px] text-[10px] font-medium min-h-[20px] rounded-full bg-primary-100 text-white-100 leading-none"
            >{{ notificationList.length }}</span
          >
        </div>
        <p
          class="cursor-pointer hover:text-primary-100 text-sm leading-none"
          :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
          @click="readAllNotification"
          v-if="notificationList.length > 0"
        >
          Mark all as read
        </p>
      </div>
      <div
        class="divide-y max-h-[250px] overflow-y-auto without-scrollbar"
        :class="mode === 'dark' ? 'divide-dark-70' : 'divide-gray-100'"
        @scroll.passive="handleScroll"
        ref="scrollContainer"
      >
        <template v-if="notificationList && notificationList.length">
          <div
            v-for="(notif, index) in notificationList"
            class="cursor-pointer p-2 flex items-start gap-2 transition-colors"
            :class="
              mode === 'dark'
                ? 'hover:bg-dark-70 bg-opacity-5'
                : 'hover:bg-primary-100 hover:bg-opacity-5'
            "
            :key="index"
            @click="handleNotificationRedirect(notif)"
          >
            <div class="w-2 h-2 rounded-full bg-primary-100 mt-1.5"></div>
            <div class="flex-1 grid gap-1.5">
              <p class="text-sm font-medium">
                {{ notif?.data?.query }}
              </p>
              <p
                class="text-sm"
                :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
              >
                {{ notif?.data.notification_text }}
              </p>
              <ul
                v-if="
                  notif.data &&
                  notif.data.low_score_list &&
                  notif.data.low_score_list.length
                "
                class="list-disc pl-3"
              >
                <li
                  v-for="(list, i) in notif.data.low_score_list"
                  :key="i"
                  class="text-sm"
                >
                  {{ list?.name }} : {{ list.value && list.value.toFixed(2) }}
                </li>
              </ul>
              <p
                class="text-sm"
                :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
              >
                {{ formatNotificationDate(notif.created_at) }}
              </p>
            </div>
          </div>
          <div v-if="isLoading" class="flex justify-center items-center">
            <span>loading...</span>
          </div>
        </template>
        <div
          v-else
          class="flex flex-col justify-center align-center px-2 py-3 text-center gap-1.5"
          :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
        >
          <span class="w-6 h-6 mx-auto">
            <BellRing :size="24" :stroke-width="1.75" />
          </span>
          No unread Notifications
        </div>
      </div>
      <div
        v-if="notificationList && notificationList.length"
        class="font-medium py-2 border-t rounded-bl-md rounded-br-md"
        :class="mode === 'dark' ? 'bg-dark-90 border-dark-50' : 'bg-white-100'"
      >
        <RouterLink
          class="flex justify-center hover:text-primary-100"
          :to="{ name: 'notifications' }"
        >
          View All
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ApiRequest from "../libs/ApiRequest";
import helper from "../libs/helper";
import { BellRing } from "lucide-vue-next";
export default {
  name: "NotificationsList",
  props: {
    mode: String,
  },
  components: {
    BellRing,
  },
  data() {
    return {
      dropdownClass: "hidden",
      notifications: [],
      nextPage: null,
      previousPage: null,
      totalNotifications: 0,
      isLoading: false,
      scrollContainer: null,
      limit: 50,
    };
  },
  mounted() {
    this.nextPage = `api/notifications?limit=${this.limit}`;
    this.loadNotifications();
  },
  computed: {
    notificationList() {
      return this.notifications
        ? this.notifications.filter((notification) => !notification.read)
        : [];
    },
  },
  methods: {
    handleScroll() {
      this.scrollContainer = this.$refs.scrollContainer;
      const scrollBottom =
        this.scrollContainer.scrollHeight -
        this.scrollContainer.scrollTop -
        this.scrollContainer.clientHeight;
      if (scrollBottom < 1 && this.nextPage && !this.isLoading) {
        this.scrollContainer.style.overflowY = "hidden";
        this.isLoading = true;
        this.loadNotifications();
      }
    },
    handleNotificationRedirect(notif) {
      this.markAsReadNotification(false, notif.id);
      if (notif.notification_type === 11) {
        this.$router.push(`/article-builder/${notif.data.notification_url}`);
      } else {
        this.$router.push(`/serp/reports`);
      }
    },
    toggleDropDown() {
      this.dropdownClass = this.dropdownClass === "block" ? "hidden" : "block";
    },
    hideDropdown() {
      if (this.dropdownClass === "block") {
        this.dropdownClass = "hidden";
      }
    },
    async loadNotifications() {
      try {
        const { data } = await ApiRequest().get(this.nextPage);
        if (data) {
          this.totalNotifications = data.count;
          this.notifications = [...this.notifications, ...data.results];
          this.nextPage = data.next;
          this.previousPage = data.previous;
          this.isLoading = false;
          if (this.scrollContainer) {
            this.scrollContainer.style.overflowY = "scroll";
          }
        }
      } catch (error) {
        this.isLoading = false;
        const extractedError = helper.extractAlert(error, "notifications");
        this.$toast.error(extractedError.alert.message);
      }
    },
    async readAllNotification() {
      if (this.notifications.length) {
        await this.markAsReadNotification(true);
      }
    },
    async markAsReadNotification(all_read = false, id) {
      const payload = {
        ...(all_read ? { mark_all_as_read: true } : {}),
        ...(id ? { notifications_ids: [id] } : {}),
      };
      try {
        const URL = `api/notifications/update_notification`;
        const { data } = await ApiRequest().post(URL, payload);
        if (data && data.success) {
          if (all_read) {
            this.notifications = [];
          } else {
            this.notifications.map((notification) => {
              if (notification.id === id) {
                notification.read = true;
              }
            });
          }
        }
      } catch (error) {
        const extractedError = helper.extractAlert(error, "notification-read");
        this.$toast.error(extractedError.alert.message);
      }
    },
    formatNotificationDate(date) {
      return moment(date).format("DD MMM YYYY");
    },
  },
};
</script>
